import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionJ() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ces2023.sectionJ');
    const { locale } = useRouter();

    const newsMap = {
        main: {
            title: t('desc1'),
            desc: t('desc2'),
            img: [`${t('newsPic')}.webp`, `${t('newsPic')}.jpg`],
            author: t.rich('author', {
                line1: (text1: any) => <span className="by">{text1}</span>,
                line2: (text2: any) => <span className="name">{text2}</span>,
            }),
            link: t('newsLink'),
        },
        list: [
            {
                title: t('news1'),
                img: [`${t('newsPic1')}.webp`, `${t('newsPic1')}.jpg`],
                author: t.rich('author1', {
                    line1: (text1: any) => <span className="by">{text1}</span>,
                    line2: (text2: any) => <span className="name">{text2}</span>,
                }),
                link: t('newsLink1'),
                locale: ['us', 'ca', 'uk', 'de', 'fr', 'cn'],
            },
            {
                title: t('news2'),
                img: [`${t('newsPic2')}.webp`, `${t('newsPic2')}.jpg`],
                author: t.rich('author2', {
                    line1: (text1: any) => <span className="by">{text1}</span>,
                    line2: (text2: any) => <span className="name">{text2}</span>,
                }),
                link: t('newsLink2'),
                locale: ['us', 'ca', 'uk', 'de', 'fr', 'cn'],
            },
            {
                title: t('news3'),
                img: [`${t('newsPic3')}.webp`, `${t('newsPic3')}.jpg`],
                author: t.rich('author3', {
                    line1: (text1: any) => <span className="by">{text1}</span>,
                    line2: (text2: any) => <span className="name">{text2}</span>,
                }),
                link: t('newsLink3'),
                locale: ['us', 'ca', 'uk', 'de', 'fr', 'cn'],
            },
            {
                title: t('news4'),
                img: [`${t('newsPic4')}.webp`, `${t('newsPic4')}.jpg`],
                author: t.rich('author4', {
                    line1: (text1: any) => <span className="by">{text1}</span>,
                    line2: (text2: any) => <span className="name">{text2}</span>,
                }),
                link: t('newsLink4'),
                locale: ['us', 'ca', 'uk', 'de', 'fr'],
            },
            {
                title: t('news5'),
                img: [`${t('newsPic5')}.webp`, `${t('newsPic5')}.jpg`],
                author: t.rich('author5', {
                    line1: (text1: any) => <span className="by">{text1}</span>,
                    line2: (text2: any) => <span className="name">{text2}</span>,
                }),
                link: t('newsLink5'),
                locale: ['us', 'ca', 'uk', 'de', 'fr'],
            },
        ],
    };

    const data = newsMap.list.filter((item) => item.locale.includes(locale));

    const linkNews = () => {
        window.open(`https://blog.ecoflow.com/${locale}`);
    };

    return (
        <div className={styles.sectionN}>
            <div className="viewport-wrapper">
                <div className="title">{t('title')}</div>
                <div className="news-wrapper">
                    <div className="left">
                        <EFPic className="news-img" name={newsMap.main.img} />
                        <div
                            className="news-title"
                            onClick={() => {
                                window.open(newsMap.main.link);
                            }}
                        >
                            {newsMap.main.title}
                        </div>
                        <div className="news-desc">{newsMap.main.desc}</div>
                        <div className="news-author">{newsMap.main.author}</div>
                    </div>
                    <div className="right">
                        {data.map((item, index) => (
                            <div className="news-panel" key={index}>
                                <div className="text">
                                    <div
                                        className="news-title"
                                        onClick={() => {
                                            window.open(item.link);
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                    <div className="news-author">{item.author}</div>
                                </div>
                                <EFPic className="news-img" name={item.img} />
                            </div>
                        ))}
                        <div className="more-news">
                            <section onClick={linkNews}>
                                <div className="text">{t('more_news')}</div>
                                <div className="icon">
                                    <EFArrowRight width="15px" height="15px" color="#FFFFFF" />
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
